  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import Checkbox                                            from '@material-ui/core/Checkbox';
//import Link                                                from '@material-ui/core/Link';
//import Radio                                               from '@material-ui/core/Radio';
//import RadioGroup                                          from '@material-ui/core/RadioGroup';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  import FormControlLabel                                    from '@material-ui/core/FormControlLabel';
//import InputLabel                                          from '@material-ui/core/InputLabel';
//import MenuItem                                            from '@material-ui/core/MenuItem';
//import FormHelperText                                      from '@material-ui/core/FormHelperText';
//import FormControl                                         from '@material-ui/core/FormControl';
//import Select                                              from '@material-ui/core/Select';
//import Autocomplete                                        from '@material-ui/lab/Autocomplete';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
//import Typography                                          from '@material-ui/core/Typography';
  //--------------------
  // 3rd party libraries
  //--------------------
  import Cookies                                             from 'js-cookie';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_TransactionFlow }                              from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  //------
  // Style
  //------
  import TransferOnline3Style                                from "./TransferOnline3Style.jsx";
  //-------
  // images
  //-------
//import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import WU_STEPS_estimate_active                            from "assets/img/wu/WU_STEPS_estimate_active.svg";
//import WU_STEPS_estimate_inactive                          from "assets/img/wu/WU_STEPS_estimate_inactive.svg";
  import WU_STEPS_progress_symbol_active                     from "assets/img/wu/WU_STEPS_progress_symbol_active.svg";
//import WU_STEPS_progress_symbol_inactive                   from "assets/img/wu/WU_STEPS_progress_symbol_inactive.svg";
  import WU_STEPS_recipient_active                           from "assets/img/wu/WU_STEPS_recipient_active.svg";
//import WU_STEPS_recipient_inactive                         from "assets/img/wu/WU_STEPS_recipient_inactive.svg";
  import WU_STEPS_review_active                              from "assets/img/wu/WU_STEPS_review_active.svg";
//import WU_STEPS_review_inactive                            from "assets/img/wu/WU_STEPS_review_inactive.svg";
  import WU_STEPS_sender_active                              from "assets/img/wu/WU_STEPS_sender_active.svg";
//import WU_STEPS_sender_inactive                            from "assets/img/wu/WU_STEPS_sender_inactive.svg";

  import WU_PAYMENT_bank_active                              from "assets/img/wu/WU_PAYMENT_bank_active.svg";
//import WU_PAYMENT_bank_inactive                            from "assets/img/wu/WU_PAYMENT_bank_inactive.svg";
//import WU_PAYMENT_card_active                              from "assets/img/wu/WU_PAYMENT_card_active.svg";
//import WU_PAYMENT_card_inactive                            from "assets/img/wu/WU_PAYMENT_card_inactive.svg";
  import WU_PAYMENT_cash_active                              from "assets/img/wu/WU_PAYMENT_cash_active.svg";
//import WU_PAYMENT_cash_inactive                            from "assets/img/wu/WU_PAYMENT_cash_inactive.svg";

//import WU_Card_logos_visa                                  from "assets/img/wu/cards/vbv.jpg";
//import WU_Card_logos_mastercard                            from "assets/img/wu/cards/sc_68x37.gif";
  //----------
  // variables
  //----------
  const filename = "TransferOnline3 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[flagsimages]
  var images = null;

  //[Lockers]
  var TransferOnline3_continue_locked = true;

class TransferOnline3 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    let viewSteps3_view_isHidden = false;
    let viewSteps4_view_isHidden = true;

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      //[DialogSpinner]
      dialog200_msg                                        : "",
      dialog200_isOpen                                     : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      viewSteps3_view_isHidden                             : viewSteps3_view_isHidden,
      viewSteps3_lbl_lbl1                                  : "",
      viewSteps3_lbl_lbl2                                  : "",
      viewSteps3_lbl_lbl3                                  : "",

      viewSteps4_view_isHidden                             : viewSteps4_view_isHidden,
      viewSteps4_lbl_lbl1                                  : "",
      viewSteps4_lbl_lbl2                                  : "",
      viewSteps4_lbl_lbl3                                  : "",
      viewSteps4_lbl_lbl4                                  : "",

      sender_fullname                                      : "",
      sender_flag_image                                    : "",
      sender_payment_method                                : WU_PAYMENT_bank_active,
      recipient_fullname                                   : "",
      recipient_flag_image                                 : "",
      recipient_transfer_method                            : WU_PAYMENT_cash_active,

      paymentMethod_text                                   : "",
      transferMethod_text                                  : "",

      lbl_d2bKeyVal01_isHidden                             : true,
      lbl_d2bKeyVal02_isHidden                             : true,
      lbl_d2bKeyVal03_isHidden                             : true,
      lbl_d2bKeyVal04_isHidden                             : true,
      lbl_d2bKeyVal05_isHidden                             : true,
      lbl_d2bKeyVal06_isHidden                             : true,
      lbl_d2bKeyVal07_isHidden                             : true,
      lbl_d2bKeyVal08_isHidden                             : true,
      lbl_d2bKeyVal09_isHidden                             : true,
      lbl_d2bKeyVal10_isHidden                             : true,

      userAcceptedTerms                                    : false,

      //consent_view_hidden                                  : false,
      //consentValue                                         : "",
      //bool_sel1                                            : false,
      //bool_sel2                                            : false,

      textField1                                           : "",
      textField1_hasError                                  : false,

      merchantReference                                    : "", //Peiraius Payment info
      user                                                 : "",
      merchantId                                           : "",
      posId                                                : "",
      acquirerId                                           : "",
      LanguageCode                                         : "",

      ShouldSaveCard                                       : false,

      //popup goBack
      dialog_goBack_msg                                      : "",
      dialog_goBack_isOpen                                   : false,

      //popup gotoController
      dialog_gotoController_msg                              : "",
      dialog_gotoController_isOpen                           : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[DialogSpinner]
    this.dialog200_handleOpen                                         = this.dialog200_handleOpen.bind(this);
    this.dialog200_handleClose                                        = this.dialog200_handleClose.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    //[SNACKBAR]for
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.makeScreenTranslations                                       = this.makeScreenTranslations.bind(this);

    this.btn_proceed_act_bank                                         = this.btn_proceed_act_bank.bind(this);
    this.btn_proceed_act_bank_isDisabled                              = this.btn_proceed_act_bank_isDisabled.bind(this);
    this.makeHTTPConn_proceed_bank                                    = this.makeHTTPConn_proceed_bank.bind(this);
    this.makeHTTPConn_proceed_bank_TagEventRecording                  = this.makeHTTPConn_proceed_bank_TagEventRecording.bind(this);
    this.btn_proceed_act_card_normal                                  = this.btn_proceed_act_card_normal.bind(this);
    this.btn_proceed_act_card_normal_isDisabled                       = this.btn_proceed_act_card_normal_isDisabled.bind(this);
    this.makeHTTPConn_proceed_card_normal                             = this.makeHTTPConn_proceed_card_normal.bind(this);
    this.btn_proceed_act_card_tokenized                               = this.btn_proceed_act_card_tokenized.bind(this);
    this.btn_proceed_act_card_tokenized_isDisabled                    = this.btn_proceed_act_card_tokenized_isDisabled.bind(this);
    this.makeHTTPConn_proceed_card_tokenized                          = this.makeHTTPConn_proceed_card_tokenized.bind(this);

    this.handleCheckBoxClick_saveNewCard                              = this.handleCheckBoxClick_saveNewCard.bind(this);

    this.handleCheckBoxClick_userAcceptedTerms                        = this.handleCheckBoxClick_userAcceptedTerms.bind(this);

  //this.handleRadioButtonClick_consent                               = this.handleRadioButtonClick_consent.bind(this);

    this.get_url_FromObj                                              = this.get_url_FromObj.bind(this);
    this.get_name_FromObj                                             = this.get_name_FromObj.bind(this);

    //popup goBack
    this.dialog_goBack_handleOpen                                     = this.dialog_goBack_handleOpen.bind(this);
    this.dialog_goBack_btn_OK                                         = this.dialog_goBack_btn_OK.bind(this);
    //popup gotoController
    this.dialog_gotoController_handleOpen                             = this.dialog_gotoController_handleOpen.bind(this);
    this.dialog_gotoController_btn_OK                                 = this.dialog_gotoController_btn_OK.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); //f(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          //if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    //[Lockers]
    this.stopLockers();

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="SettingsPrivacy" ||
       localStorage.getItem("prev_view").trim()==="SettingsTerms"   ){
      if(api.print_logs){console.log("Do nothing if...");}
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){console.log(methName+"err="+JSON.stringify(err));}
      return;
    }
    //---------------------------------
    //Clear Previous Payment(if exists)
    //---------------------------------
    this.setState({
      merchantReference                                    : "",
      user                                                 : "",
      merchantId                                           : "",
      posId                                                : "",
      acquirerId                                           : "",
      LanguageCode                                         : "",
    });
    //---------------------------
    //Peiraius Private Mode Issue
    //---------------------------
    this.load_cookies_to_localStorage();
    //wu_Utilities.printSomeValuesFromLocalStorage();

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("please_wait"));} //start DialogSpinner only if network connection will take place
    //-------------------
    //wu_validatecustomer
    //-------------------
    wu_ProfileService
    .wu_validatecustomer({})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));

      //[flagsimages]
      images = this.importAll(require.context('assets/img/flagspng/', false, /\.(png|svg)$/));
      //if(api.print_logs){console.log("images.length="+images.length);}
      //for (var key in images) { if(api.print_logs){console.log("key="+key);} }


      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---componentWillMount
      this.makeScreenTranslations();
    })
    .catch(err => {
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---componentWillMount
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-02)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    const path_SettingsTerms   = api.webapp_path+"/SettingsTerms";
    const path_SettingsPrivacy = api.webapp_path+"/SettingsPrivacy";

    let moreURL = (localStorage.getItem("lang")==="en") ? "https://www.westernunion.gr/en/fraud-awareness/" : "https://www.westernunion.gr/enimerosi-apati/";

    let transferMethod_text = localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Bank ? this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1") : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1");
    let paymentMethod_text = localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer ? this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1") : this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1");

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>
            {/* ------------------------- */}
            {/* ----------[STEPS3]------- */}
            {/* ------------------------- */}
            {this.state.viewSteps3_view_isHidden === true ? ( "" ) : (
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl1")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={3}>
                    <div className={classes.viewSteps3Label}>&nbsp;</div>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_recipient_active} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl2")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={3}>
                    <div className={classes.viewSteps3Label}>&nbsp;</div>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={2}>
                    <div className={classes.viewSteps3Image}><img src={WU_STEPS_review_active} alt=""/></div>
                    <div className={classes.viewSteps3Label}>{this.NSInforString("TransferOnline123_viewSteps3_lbl_lbl3")}</div>
                  </GridItem>
                </GridContainer>
              </div>
            )}
            {/* ------------------------- */}
            {/* ----------[STEPS4]------- */}
            {/* ------------------------- */}
            {this.state.viewSteps4_view_isHidden === true ? ( "" ) : (
              <div style={{ marginTop: 20 }}>
                <GridContainer justify="center">
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_estimate_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl1")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_sender_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl2")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_recipient_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl3")}</div>
                  </GridItem>
                  <GridItem xs={1} sm={1} md={1}>
                    <div className={classes.viewSteps4Label}>&nbsp;</div>
                    <div className={classes.viewSteps4ImageDots}><img src={WU_STEPS_progress_symbol_active} alt=""/></div>
                  </GridItem>
                  <GridItem xs={2} sm={2} md={2}>
                    <div className={classes.viewSteps4Image}><img src={WU_STEPS_review_active} alt=""/></div>
                    <div className={classes.viewSteps4Label}>{this.NSInforString("TransferOnline123_viewSteps4_lbl_lbl4")}</div>
                  </GridItem>
                </GridContainer>
              </div>
            )}
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline3_lbl_header_reviewAndConfirm}>{this.NSInforString("TransferOnline3_lbl_header_reviewAndConfirm")}</div>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------ROW------------ */}
            {/* ------------------------- */}
            <GridContainer justify="center">
              {/* ----------Sender------------ */}
              <GridItem xs={12} sm={12} md={6}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      style={{
                        '&.Mui-disabled:hover::before': {
                        borderColor: 'inherit',
                        },
                      }}
                      id="standard-read-only-input1"
                      label=""
                      value={this.NSInforString("TransferOnline3_key02")}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer justify="center">
                      <GridItem xs={2} sm={2} md={2}><div className={classes.senderRecipientDetails_flagimage}><img width="30px" height="20px" src={this.state.sender_flag_image} alt="" /></div></GridItem>
                      <GridItem xs={10} sm={10} md={10}><div className={classes.senderRecipientDetails_label}>{this.state.sender_fullname}</div></GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer justify="center">
                      <GridItem xs={2} sm={2} md={2}><div className={classes.senderRecipientDetails_image}><img width="30px" height="30px" src={this.state.sender_payment_method} alt="" /></div></GridItem>
                      <GridItem xs={10} sm={10} md={10}><div className={classes.senderRecipientDetails_label}>{paymentMethod_text}</div></GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>
              {/* ----------Receiver------------ */}
              <GridItem xs={12} sm={12} md={6}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      className={classes.notHover}
                      fullWidth
                      id="standard-read-only-input2"
                      label=""
                      value={this.NSInforString("TransferOnline3_key03")}
                      InputProps={{ fullWidth:true, readOnly:true}}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer justify="center">
                      <GridItem xs={2} sm={2} md={2}><div className={classes.senderRecipientDetails_flagimage}><img width="30px" height="20px" src={this.state.recipient_flag_image} alt="" /></div></GridItem>
                      <GridItem xs={10} sm={10} md={10}><div className={classes.senderRecipientDetails_label}>{this.state.recipient_fullname}</div></GridItem>
                    </GridContainer>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer justify="center">
                      <GridItem xs={2} sm={2} md={2}><div className={classes.senderRecipientDetails_image}><img width="30px" height="30px" src={this.state.recipient_transfer_method} alt="" /></div></GridItem>
                      <GridItem xs={10} sm={10} md={10}><div className={classes.senderRecipientDetails_label}>{transferMethod_text}</div></GridItem>
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
            {/* ------------------------- */}
            {/* ----------[SUMMARY]------ */}
            {/* ------------------------- */}
            <div style={{ marginTop: 20 }}>
              <GridContainer justify="center">
                {/* ----------Sender------------ */}
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    id="standard-read-only-input3"
                    label=""
                    value={this.NSInforString("TransferOnline3_Summary")}
                    InputProps={{ fullWidth:true, readOnly:true}}
                  />
                </GridItem>
              </GridContainer>
            </div>

            <div style={{ marginTop:10, marginBottom:20, "backgroundColor":"#EAEBED", padding:"0.8rem" }}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <GridContainer justify="center" style={{ marginTop:0}}>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline3_key07")}</div></GridItem>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.paraliptisLambanei}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center" style={{ marginTop:10}}>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline3_key06")}</div></GridItem>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.plirwneis}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center" style={{ marginTop:10}}>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline3_key09X")}</div></GridItem>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.eksoda}</div></GridItem>
                  </GridContainer>
                  <GridContainer justify="center" style={{ marginTop:10}}>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.NSInforString("TransferOnline3_key10")}</div></GridItem>
                    <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.sunolikoKostos}</div></GridItem>
                  </GridContainer>
                  {this.state.lbl_d2bKeyVal01_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey01}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal01}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal02_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey02}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal02}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal03_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey03}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal03}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal04_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey04}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal04}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal05_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey05}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal05}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal06_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey06}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal06}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal07_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey07}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal07}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal08_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey08}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal08}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal09_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey09}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal09}</div></GridItem>
                    </GridContainer>
                  )}
                  {this.state.lbl_d2bKeyVal10_isHidden === true ? ( "" ) : (
                    <GridContainer justify="center" style={{ marginTop:10}}>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_key}>{this.state.lbl_d2bKey10}</div></GridItem>
                      <GridItem xs={6} sm={6} md={6}><div className={classes.viewRN_val}>{this.state.lbl_d2bVal10}</div></GridItem>
                    </GridContainer>
                  )}
                </GridItem>
              </GridContainer>
            </div>
            {/* --------------------------------- */}
            {/* ----------[Card Holder]---------- */}
            {/* --------------------------------- */}
            {localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ? (
              <div style={{ marginTop:25, marginBottom:15 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.TransferOnline3_lbl_cardHolderName}>{this.NSInforString("TransferOnline3_lbl_cardHolderName")}</div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <TextField
                      fullWidth
                      error={this.state.textField1_hasError}
                      className={classes.textField1}
                      id="textField1"
                      label={this.NSInforString("TransferOnline3_plh1")}
                      value={this.state.textField1}
                      InputProps={{
                        fullWidth: true,
                        onChange: event => this.change(event, "textField1"),
                        type: "text"
                      }}
                    />
                  </GridItem>
                </GridContainer>
              </div>
            ) : ("") }

            {/* --------------------------------- */}
            {/* ----------[Save New Card]-------- */}
            {/* --------------------------------- */}
            {localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ?
            (
            <GridContainer justify="center" style={{ marginTop:10}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_saveNewCard}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div className={classes.TransferOnline3_ViewCardSave_lbl_info}>{this.NSInforString("TransferOnline3_ViewCardSave_lbl_info")}</div>
              </GridItem>
              {/* <GridItem xs={12} sm={12} md={12} style={{ marginTop:0, marginBottom:0}}>
                <TextField
                  fullWidth
                  id="standard-read-only-input1"
                  label=""
                  value=""
                  InputProps={{ fullWidth:true, readOnly:true, style: {height:1} }}
                />
              </GridItem> */}
            </GridContainer>
            ) : ( "" )
            }
            {/* ------------------------- */}
            {/* ----------[Fraud]-------- */}
            {/* ------------------------- */}
            <div style={{ marginTop: 20 }}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline3_lbl_fraud1}>{this.NSInforString("TransferOnline3_lbl_fraud1")}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline3_lbl_fraud2}>{this.NSInforString("TransferOnline3_lbl_fraud2")}</div>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.TransferOnline3_lbl_fraud3}>{this.NSInforString("TransferOnline3_lbl_fraud3")}<a href={moreURL} target="_blank" rel="noopener noreferrer"><u>{this.NSInforString("TransferOnline3_lbl_fraud4")}</u></a></div>
              </GridItem>
            </GridContainer>
            </div>
            {/* ------------------------- */}
            {/* ----------[Consent]------ */}
            {/* ------------------------- */}
            {/* {this.state.consent_view_hidden === true ? ( "" ) : (
              <div style={{ marginTop:25, marginBottom:25}}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <div className={classes.TransferOnline3_lbl_consent1}>{this.NSInforString("TransferOnline3_lbl_consent1")}</div>
                  </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                    <RadioGroup aria-label="gender" name="gender1" value={this.state.consentValue} onChange={this.handleRadioButtonClick_consent}>
                      <FormControlLabel value="true"  control={<Radio />} label={<Typography className={classes.TransferOnline3_lbl_consentOptions}>{this.NSInforString("TransferOnline3_lbl_sel1")}</Typography>} />
                      <FormControlLabel value="false" control={<Radio />} label={<Typography className={classes.TransferOnline3_lbl_consentOptions}>{this.NSInforString("TransferOnline3_lbl_sel2")}</Typography>} />
                    </RadioGroup>
                  </GridItem>
                </GridContainer>
              </div>
            )}*/}
            {/* ------------------------- */}
            {/* ----------[Terms]-------- */}
            {/* ------------------------- */}
            {localStorage.getItem("lang")==="en" ?
            (
            <GridContainer justify="center" style={{ marginTop:10}}>
              <GridItem xs={2} sm={1} md={1}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleCheckBoxClick_userAcceptedTerms}
                      value="checkedA"
                      inputProps={{ 'aria-label': 'Checkbox A' }}
                    />
                  }
                  label=""
                />
              </GridItem>
              <GridItem xs={10} sm={11} md={11}>
                <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>I have read and accept the <NavLink activeClassName="active" exact to={path_SettingsTerms}>Terms & Conditions</NavLink> and I have been informed about the <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Privacy Statement</NavLink></span></div>
              </GridItem>
            </GridContainer>
            ) :
            (
              <GridContainer justify="center" style={{ marginTop:10}}>
                <GridItem xs={2} sm={1} md={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={this.handleCheckBoxClick_userAcceptedTerms}
                        value="checkedA"
                        inputProps={{ 'aria-label': 'Checkbox A' }}
                      />
                    }
                    label=""
                  />
                </GridItem>
                <GridItem xs={10} sm={11} md={11}>
                  <div style={{ paddingLeft:0, marginLeft:-10, textAlign:"left" }}><span style={{fontFamily:"Helvetica", fontWeight:"300",  color:"#1A1A1A", marginTop:0}}>Διάβασα και αποδέχομαι τους <NavLink activeClassName="active" exact to={path_SettingsTerms}>Όρους & Προϋποθέσεις</NavLink> και ενημερώθηκα για την <NavLink activeClassName="active" exact to={path_SettingsPrivacy}>Πολιτική Προσωπικών Δεδομένων</NavLink></span></div>
                </GridItem>
              </GridContainer>
            )
            }
            {localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard ? (
              <div style={{ marginTop:25 }}>
                <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.TransferOnline3_lbl_card12}>{this.NSInforString("TransferOnline3_lbl_card1")}{/* <img height="28" src={WU_Card_logos_visa} alt=""/><img height="30" src={WU_Card_logos_mastercard} alt=""/>*/}</div>
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={12}>
                      <div className={classes.TransferOnline3_lbl_card12}>{this.NSInforString("TransferOnline3_lbl_card2")}</div>
                  </GridItem> */}
                </GridContainer>
              </div>
            ) : ("") }
            {/* ------------------------- */}
            {/* ----------[SPINNERS]----- */}
            {/* ------------------------- */}
            {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
              <GridContainer justify="center">
                <GridItem xs={3} sm={3} md={3}></GridItem>
                <GridItem xs={6} sm={6} md={6}>
                  <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}></GridItem>
              </GridContainer>
            )}
            {/* -------------------------------------------------- */}
            {/* ----------[BUTTONS BankTransfer]------------------ */}
            {/* -------------------------------------------------- */}
            {(localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer) ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.btn_proceed_act_bank_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_proceed_act_bank}
                      type="submit">
                      {this.NSInforString("TransferOnline3_btn_proceed")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" )
            }
            {/* -------------------------------------------------- */}
            {/* ----------[BUTTONS CreditCard Normal]------------- */}
            {/* -------------------------------------------------- */}
            {localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Normal" ? (
              <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <form id="cardPaymentFormNormal" action={api.url_onlinemt+api.webapp_path+"/outbound/wbwu/redirect"} method="post">
                    {/* Peiraius Payment info */}
                    <input type="hidden" id="merchantReference"              name="merchantReference"              value={this.state.merchantReference}/>
                    <input type="hidden" id="user"                           name="user"                           value={this.state.user}/>
                    <input type="hidden" id="merchantId"                     name="merchantId"                     value={this.state.merchantId}/>
                    <input type="hidden" id="posId"                          name="posId"                          value={this.state.posId}/>
                    <input type="hidden" id="acquirerId"                     name="acquirerId"                     value={this.state.acquirerId}/>
                    <input type="hidden" id="LanguageCode"                   name="LanguageCode"                   value={this.state.LanguageCode}/>
                    {/* Session between domains : webapp & mobile */}
                    <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
                    <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
                    {/* Session between domains : webapp */}
                    <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
                    <input type="hidden" id="centralID"                      name="centralID"                      value={this.get_centralID()}/>
                    <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
                    <input type="hidden" id="TransferOnline1_PaymentMethod"  name="TransferOnline1_PaymentMethod"  value={localStorage.getItem("TransferOnline1_PaymentMethod")}/>
                    <input type="hidden" id="TransferOnline1_TransferMethod" name="TransferOnline1_TransferMethod" value={localStorage.getItem("TransferOnline1_TransferMethod")}/>
                    <input type="hidden" id="gross"                          name="gross"                          value={this.get_gross()}/>
                    <input type="hidden" id="normalCharges"                  name="normalCharges"                  value={this.get_normalCharges()}/>
                    <input type="hidden" id="expectedActualPayout"           name="expectedActualPayout"           value={this.get_expectedActualPayout()}/>
                    <input type="hidden" id="principal"                      name="principal"                      value={this.get_principal()}/>
                    <input type="hidden" id="rcv_curr"                       name="rcv_curr"                       value={this.get_rcv_curr()}/>
                    <input type="hidden" id="rcv_fname"                      name="rcv_fname"                      value={this.get_rcv_fname()}/>
                    <input type="hidden" id="rcv_lname"                      name="rcv_lname"                      value={this.get_rcv_lname()}/>
                    </form>
                  </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.btn_proceed_act_card_normal_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_proceed_act_card_normal}
                      type="submit">
                      {this.NSInforString("TransferOnline3_btn_proceed")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" )
            }
            {/* -------------------------------------------------- */}
            {/* ----------[BUTTONS CreditCard Tokenized]---------- */}
            {/* -------------------------------------------------- */}
            {localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_CreditCard && localStorage.getItem("payWithCardMethod")==="payWithCardMethod_Tokenized" ? (
              <GridContainer justify="center">
                  <GridItem xs={10} sm={10} md={10}>
                    <form id="cardPaymentFormTokenized" action={api.url_onlinemt+api.webapp_path+"/transfers/bank/tokenized/redirect"} method="post">
                    {/* Peiraius Payment info */}
                    <input type="hidden" id="html"                           name="html"                           value={this.state.html}/>
                    <input type="hidden" id="MTCN"                           name="MTCN"                           value={this.state.MTCN}/>
                    <input type="hidden" id="LanguageCode"                   name="LanguageCode"                   value={this.state.LanguageCode}/>
                    {/* Session between domains : webapp & mobile */}
                    <input type="hidden" id="platform"                       name="platform"                       value="webapp-react"/>
                    <input type="hidden" id="accessToken"                    name="accessToken"                    value={localStorage.getItem("accessToken")}/>
                    {/* Session between domains : webapp */}
                    <input type="hidden" id="tokenID"                        name="tokenID"                        value={localStorage.getItem("tokenID")}/>
                    <input type="hidden" id="centralID"                      name="centralID"                      value={this.get_centralID()}/>
                    <input type="hidden" id="refreshToken"                   name="refreshToken"                   value={localStorage.getItem("refreshToken")}/>
                    <input type="hidden" id="TransferOnline1_PaymentMethod"  name="TransferOnline1_PaymentMethod"  value={localStorage.getItem("TransferOnline1_PaymentMethod")}/>
                    <input type="hidden" id="TransferOnline1_TransferMethod" name="TransferOnline1_TransferMethod" value={localStorage.getItem("TransferOnline1_TransferMethod")}/>
                    <input type="hidden" id="gross"                          name="gross"                          value={this.get_gross()}/>
                    <input type="hidden" id="normalCharges"                  name="normalCharges"                  value={this.get_normalCharges()}/>
                    <input type="hidden" id="expectedActualPayout"           name="expectedActualPayout"           value={this.get_expectedActualPayout()}/>
                    <input type="hidden" id="principal"                      name="principal"                      value={this.get_principal()}/>
                    <input type="hidden" id="rcv_curr"                       name="rcv_curr"                       value={this.get_rcv_curr()}/>
                    <input type="hidden" id="rcv_fname"                      name="rcv_fname"                      value={this.get_rcv_fname()}/>
                    <input type="hidden" id="rcv_lname"                      name="rcv_lname"                      value={this.get_rcv_lname()}/>
                    </form>
                  </GridItem>
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.btn_proceed_act_card_tokenized_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.btn_proceed_act_card_tokenized}
                      type="submit">
                      {this.NSInforString("TransferOnline3_btn_proceed")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" )
            }
            {/* -------------------------------------------------- */}
            {/* ----------[BUTTONS Back]-------------------------- */}
            {/* -------------------------------------------------- */}
            {api.backButtonAtBottom === true ? (
              <GridContainer justify="center">
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("TransferOnline3_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              </GridContainer>
            ) : ( "" ) }

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP goBack]---------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_goBack_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_goBack_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_goBack_msg}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_goBack_btn_OK}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP gotoController]-------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_gotoController_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_gotoController_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_gotoController_msg}</div></GridItem>
              <GridItem xs={12} sm={12} md={12}></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_gotoController_btn_OK}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------- */}
        {/* ----------[DialogSpinner]--- */}
        {/* ---------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog200_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog200_handleClose}
            aria-labelledby="alert-dialog200-slide-title"
            aria-describedby="alert-dialog200-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <div className={classes.pleaseWaitPopup}><CircularProgress/><span>&nbsp;{this.state.dialog200_msg}</span></div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    );
  }
  //-------------------------------------------------------------------------------------------------------------------------------
  makeScreenTranslations(){
      let methName = filename+"makeScreenTranslations ";
      //if(api.print_logs){console.log(methName);}

      let parserObject_validatecustomer = {};
      try{ parserObject_validatecustomer = JSON.parse(localStorage.getItem("parserObject_validatecustomer"));}catch(err){console.log(methName+'err='+err);}
      //if(api.print_logs){console.log('parserObject_validatecustomer='+parserObject_validatecustomer);}

      //------
      //Sender
      //------
      var fname = "";
      var lname = "";
      try {fname = parserObject_validatecustomer["fname"];   }catch(err){;} if(fname === null){fname = "";}
      try {lname = parserObject_validatecustomer["lname"];   }catch(err){;} if(lname === null){lname = "";}
      //---------
      //Recipient
      //---------
      let rcv_fname   = "";
      let rcv_lname   = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b_req = {};
          try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
          //if(api.print_logs){console.log('parserObject_sendoutbound_d2b_req='+localStorage.getItem("parserObject_sendoutbound_d2b_req"));}
          try {rcv_fname = parserObject_sendoutbound_d2b_req["rcv_fname"]; }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
          try {rcv_lname = parserObject_sendoutbound_d2b_req["rcv_lname"]; }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
      }
      else{
          let parserObject_sendoutbound_req = {};
          try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
          //if(api.print_logs){console.log('parserObject_sendoutbound_req='+localStorage.getItem("parserObject_sendoutbound_req"));}
          try {rcv_fname = parserObject_sendoutbound_req["rcv_fname"]; }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
          try {rcv_lname = parserObject_sendoutbound_req["rcv_lname"]; }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
      }
      //--------------
      //Payment Method
      //--------------
      //let paymentMethod_text = localStorage.getItem("TransferOnline1_PaymentMethod_str");
      let paymentMethod_text = localStorage.getItem("TransferOnline1_PaymentMethod")===api.TransferOnline1_PaymentMethod_BankTransfer ? this.NSInforString("TransferOnline_viewPM_lbl_BT_lb1") : this.NSInforString("TransferOnline_viewPM_lbl_CC_lb1");
      //---------------
      //Transfer Method
      //---------------
      //let transferMethod_text = localStorage.getItem("TransferOnline1_TransferMethod_str");
      let transferMethod_text = localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Bank ? this.NSInforString("TransferOnline_viewTM_lbl_BA_lb1") : this.NSInforString("TransferOnline_viewTM_lbl_CM_lb1");
      //-----------
      //Destination
      //-----------
      let destCountryDescription = localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id");
      //--------------
      //Amount to Send
      //--------------
      let gross                = 0.0; //float
      let normalCharges        = 0.0; //float
      let expectedActualPayout = 0.0; //float
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_validateoutbound_d2b = {};
          try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err){;}
          try {gross                = parserObject_validateoutbound_d2b["gross"];                 }catch(err){;} if(gross                === null || (typeof gross==="undefined")){ gross = 0.0;}
          try {normalCharges        = parserObject_validateoutbound_d2b["normalCharges"];         }catch(err){;} if(normalCharges        === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
          try {expectedActualPayout = parserObject_validateoutbound_d2b["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
      }
      else{
          let parserObject_validateoutbound = {};
          try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err){;}
          try {gross                = parserObject_validateoutbound["gross"];                 }catch(err){;} if(gross                === null || (typeof gross==="undefined")){ gross = 0.0;}
          try {normalCharges        = parserObject_validateoutbound["normalCharges"];         }catch(err){;} if(normalCharges        === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
          try {expectedActualPayout = parserObject_validateoutbound["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
      }
      //-----------------
      //Receiver Currency
      //-----------------
      let rcv_curr   = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b_req = {};
          try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
          try {rcv_curr = parserObject_sendoutbound_d2b_req["rcv_curr"]; }catch(err){;}
          if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
      }
      else{
          let parserObject_sendoutbound_req = {};
          try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
          try {rcv_curr = parserObject_sendoutbound_req["rcv_curr"]; }catch(err){;}
          if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
      }
      //-----------------
      //Amount to Receive
      //-----------------
      let principal = 0.0;
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b_req = {};
          try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
          try {principal = parserObject_sendoutbound_d2b_req["principal"]; }catch(err){;}
      }
      else{
          let parserObject_sendoutbound_req = {};
          try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
          try {principal = parserObject_sendoutbound_req["principal"]; }catch(err){;}
      }

      //D2B Fields
      let lbl_d2bKeyVal01_isHidden=true; let lbl_d2bKey01 = ""; let lbl_d2bVal01 = "";
      let lbl_d2bKeyVal02_isHidden=true; let lbl_d2bKey02 = ""; let lbl_d2bVal02 = "";
      let lbl_d2bKeyVal03_isHidden=true; let lbl_d2bKey03 = ""; let lbl_d2bVal03 = "";
      let lbl_d2bKeyVal04_isHidden=true; let lbl_d2bKey04 = ""; let lbl_d2bVal04 = "";
      let lbl_d2bKeyVal05_isHidden=true; let lbl_d2bKey05 = ""; let lbl_d2bVal05 = "";
      let lbl_d2bKeyVal06_isHidden=true; let lbl_d2bKey06 = ""; let lbl_d2bVal06 = "";
      let lbl_d2bKeyVal07_isHidden=true; let lbl_d2bKey07 = ""; let lbl_d2bVal07 = "";
      let lbl_d2bKeyVal08_isHidden=true; let lbl_d2bKey08 = ""; let lbl_d2bVal08 = "";
      let lbl_d2bKeyVal09_isHidden=true; let lbl_d2bKey09 = ""; let lbl_d2bVal09 = "";
      let lbl_d2bKeyVal10_isHidden=true; let lbl_d2bKey10 = ""; let lbl_d2bVal10 = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_getd2bfields_JSON = {};
          try { parserObject_getd2bfields_JSON = JSON.parse(localStorage.getItem("parserObject_getd2bfields_JSON")); }catch(err){;}
          for(let i=0; i<parserObject_getd2bfields_JSON.length; ++i){
              let fieldName = "";
              let value     = "";
              try {fieldName = parserObject_getd2bfields_JSON[i]["fieldName"];}catch(err){ ; }
              try {value     = parserObject_getd2bfields_JSON[i]["value"];    }catch(err){ ; }
              if(i===0){lbl_d2bKeyVal01_isHidden=false; lbl_d2bKey01 = fieldName; lbl_d2bVal01 = value;}
              if(i===1){lbl_d2bKeyVal02_isHidden=false; lbl_d2bKey02 = fieldName; lbl_d2bVal02 = value;}
              if(i===2){lbl_d2bKeyVal03_isHidden=false; lbl_d2bKey03 = fieldName; lbl_d2bVal03 = value;}
              if(i===3){lbl_d2bKeyVal04_isHidden=false; lbl_d2bKey04 = fieldName; lbl_d2bVal04 = value;}
              if(i===4){lbl_d2bKeyVal05_isHidden=false; lbl_d2bKey05 = fieldName; lbl_d2bVal05 = value;}
              if(i===5){lbl_d2bKeyVal06_isHidden=false; lbl_d2bKey06 = fieldName; lbl_d2bVal06 = value;}
              if(i===6){lbl_d2bKeyVal07_isHidden=false; lbl_d2bKey07 = fieldName; lbl_d2bVal07 = value;}
              if(i===7){lbl_d2bKeyVal08_isHidden=false; lbl_d2bKey08 = fieldName; lbl_d2bVal08 = value;}
              if(i===8){lbl_d2bKeyVal09_isHidden=false; lbl_d2bKey09 = fieldName; lbl_d2bVal09 = value;}
              if(i===9){lbl_d2bKeyVal10_isHidden=false; lbl_d2bKey10 = fieldName; lbl_d2bVal10 = value;}
          }
      }

      let ctry_iso_id = "";
      try { ctry_iso_id = parserObject_validatecustomer["ctry_iso_id"]; }catch(err){;} if(ctry_iso_id === null || (typeof ctry_iso_id ==="undefined")){ctry_iso_id = "";}

      this.setState({
        "sender_fullname"          : fname+" "+lname,
        "recipient_fullname"       : rcv_fname+" "+rcv_lname,
        "paymentMethod_text"       : paymentMethod_text,
        "transferMethod_text"      : transferMethod_text,
        //FORMAT 10000.00
        // "plirwneis"                : parseFloat(principal).toFixed(2)+" EUR",
        // "eksoda"                   : normalCharges.toFixed(2)+" EUR",
        // "paraliptisLambanei"       : expectedActualPayout.toFixed(2) + " " + rcv_curr,
        // "sunolikoKostos"           : gross.toFixed(2)+" EUR",
        //FORMAT 10.000,00
        "plirwneis"                : this.comvert2ProperAmountFormat(parseFloat(principal).toFixed(2))+" EUR",
        "eksoda"                   : this.comvert2ProperAmountFormat(normalCharges.toFixed(2))+" EUR",
        "paraliptisLambanei"       : this.comvert2ProperAmountFormat(expectedActualPayout.toFixed(2)) + " " + rcv_curr,
        "sunolikoKostos"           : this.comvert2ProperAmountFormat(gross.toFixed(2))+" EUR",

        "lbl_d2bKeyVal01_isHidden" : lbl_d2bKeyVal01_isHidden,
        "lbl_d2bKeyVal02_isHidden" : lbl_d2bKeyVal02_isHidden,
        "lbl_d2bKeyVal03_isHidden" : lbl_d2bKeyVal03_isHidden,
        "lbl_d2bKeyVal04_isHidden" : lbl_d2bKeyVal04_isHidden,
        "lbl_d2bKeyVal05_isHidden" : lbl_d2bKeyVal05_isHidden,
        "lbl_d2bKeyVal06_isHidden" : lbl_d2bKeyVal06_isHidden,
        "lbl_d2bKeyVal07_isHidden" : lbl_d2bKeyVal07_isHidden,
        "lbl_d2bKeyVal08_isHidden" : lbl_d2bKeyVal08_isHidden,
        "lbl_d2bKeyVal09_isHidden" : lbl_d2bKeyVal09_isHidden,
        "lbl_d2bKeyVal10_isHidden" : lbl_d2bKeyVal10_isHidden,

        "lbl_d2bKey01"             : lbl_d2bKey01,
        "lbl_d2bKey02"             : lbl_d2bKey02,
        "lbl_d2bKey03"             : lbl_d2bKey03,
        "lbl_d2bKey04"             : lbl_d2bKey04,
        "lbl_d2bKey05"             : lbl_d2bKey05,
        "lbl_d2bKey06"             : lbl_d2bKey06,
        "lbl_d2bKey07"             : lbl_d2bKey07,
        "lbl_d2bKey08"             : lbl_d2bKey08,
        "lbl_d2bKey09"             : lbl_d2bKey09,
        "lbl_d2bKey10"             : lbl_d2bKey10,

        "lbl_d2bVal01"             : lbl_d2bVal01,
        "lbl_d2bVal02"             : lbl_d2bVal02,
        "lbl_d2bVal03"             : lbl_d2bVal03,
        "lbl_d2bVal04"             : lbl_d2bVal04,
        "lbl_d2bVal05"             : lbl_d2bVal05,
        "lbl_d2bVal06"             : lbl_d2bVal06,
        "lbl_d2bVal07"             : lbl_d2bVal07,
        "lbl_d2bVal08"             : lbl_d2bVal08,
        "lbl_d2bVal09"             : lbl_d2bVal09,
        "lbl_d2bVal10"             : lbl_d2bVal10,

        "sender_flag_image"        : ctry_iso_id!=="" ? images[ctry_iso_id.toLowerCase()+".png"] : images["gr.png"],
        "recipient_flag_image"     : images[destCountryDescription.toLowerCase()+".png"],

        // "sender_flag_image"        : images["gr.png"],
        // "recipient_flag_image"     : images["gb.png"],
      });
      if(api.print_logs){console.log('destCountryDescription='+destCountryDescription.toLowerCase());}

      /*//consent-offers
      let wantMktInfo = -1;
      try {wantMktInfo = parserObject_validatecustomer["wantMktInfo"]; }catch(err){wantMktInfo = -1;}
      //nailed for testing:START---inactive
      //wantMktInfo = -1;
      //nailed for testing:END
      if(wantMktInfo===1){
          this.setState({ "bool_sel1":true,  "bool_sel2":false, "consent_view_hidden":true});
      }
      else if(wantMktInfo===0){
          this.setState({ "bool_sel1":false, "bool_sel2":false, "consent_view_hidden":false});
      }
      else{
          this.setState({ "bool_sel1":false, "bool_sel2":false, "consent_view_hidden":false});
      }*/

      if(Cookies.get('wuwb4c_cardPaymentStatus')==="failure" && Cookies.get('wuwb4c_customerCancelled')!=="true" ){
        var ResultCode_int = 0;
        var ResultCode_str = "";
        try{ ResultCode_int = parseInt(Cookies.get('wuwb4c_ResultCode')); }catch(err){;}
        try{ ResultCode_str = Cookies.get('wuwb4c_ResultCode'); }catch(err){;}
        if([6001, 500, 501, 1040, 1041, 1072, 7001].includes(ResultCode_int) || ResultCode_str.startsWith("50")){ this.dialog_handleOpen(               this.NSInforString("TransferOnline3_lbl_card_error_1")); } //===>TransferOnline3(STAY in the same screen)
        else if([6002, 1048, 1045].includes(ResultCode_int))                                                    { this.dialog_gotoController_handleOpen(this.NSInforString("TransferOnline3_lbl_card_error_2")); } //===>HistoryList
        else if([6003].includes(ResultCode_int))                                                                { this.dialog_goBack_handleOpen(        this.NSInforString("TransferOnline3_lbl_card_error_3")); } //===>TransferOnlineCards
        else if([6004, 100, 130, 151, 215, 216, 981, 1802].includes(ResultCode_int))                            { this.dialog_handleOpen(               this.NSInforString("TransferOnline3_lbl_card_error_4")); } //===>TransferOnline3(STAY in the same screen)
        else                                                                                                    { this.dialog_handleOpen(               this.NSInforString("TransferOnline3_lbl_card_error"));   } //===>TransferOnline3(STAY in the same screen)
        Cookies.set('wuwb4c_cardPaymentStatus',"");
      }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------CheckBox Listeners--------------------------------
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_userAcceptedTerms(event) {
    let methName = filename+"handleCheckBoxClick_userAcceptedTerms ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "userAcceptedTerms":event.target.checked });
  }
  //----------------------------------------------------------------------------------------------------
  handleCheckBoxClick_saveNewCard(event) {
    let methName = filename+"handleCheckBoxClick_saveNewCard ";
    if(api.print_logs){console.log(methName+event.target.checked);}
    this.setState({ "ShouldSaveCard":event.target.checked });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------RadioButton Listeners-----------------------------
  //----------------------------------------------------------------------------------------------------
  /*handleRadioButtonClick_consent(event) {
    let methName = filename+"handleRadioButtonClick_consent ";
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(methName+eventTMP);}

    if(eventTMP==="true"){
      localStorage.setItem("wantMktInfo","1");
      this.setState({
        "consentValue" : eventTMP,
        "bool_sel1"    : true,
        "bool_sel2"    : false
      });
    }
    else{
      localStorage.setItem("wantMktInfo","0");
      this.setState({
        "consentValue" : eventTMP,
        "bool_sel1"    : false,
        "bool_sel2"    : true
      });
    }
  }*/
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_tokenized_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_tokenized(event) {
    let methName = filename+"btn_proceed_act_card_tokenized ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){this.stopLockers();return;}
    }
    //----------------
    //validate Consent
    //----------------
    /*if(this.state.bool_sel1===false && this.state.bool_sel2===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_consent_err"));
        this.stopLockers();return;
    }*/
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_msg_terms"));
        this.stopLockers();return;
    }

    this.makeHTTPConn_proceed_card_tokenized();
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_card_tokenized(){
    let methName = filename+"makeHTTPConn_proceed_card_tokenized ";
    if(api.print_logs){console.log(methName);}

    //-----------------
    //wu_cardpaymentpay
    //-----------------
    var parserObject_transfers_payment_pay_req = {};

    let centralID = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b = {};
        try { parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b")); }catch(err){;}
        try { centralID = parserObject_sendoutbound_d2b["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
    }
    else{
        let parserObject_sendoutbound = {};
        try { parserObject_sendoutbound = JSON.parse(localStorage.getItem("parserObject_sendoutbound")); }catch(err){;}
        try { centralID = parserObject_sendoutbound["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
    }

    var token = "";
    let parserObject_selectedTokenizedCard = {};
    try { parserObject_selectedTokenizedCard = JSON.parse(localStorage.getItem("parserObject_selectedTokenizedCard")); }catch(err){;}
    try { token = parserObject_selectedTokenizedCard["token"]; }catch(err){;} if(token === null || (typeof token ==="undefined")){token = "";}

    parserObject_transfers_payment_pay_req["token"]     = token;
    parserObject_transfers_payment_pay_req["centralID"] = centralID;

    //screenWidth,screenHeight,timezone
    parserObject_transfers_payment_pay_req["screenWidth"]  = String(window.innerWidth);
    parserObject_transfers_payment_pay_req["screenHeight"] = String(window.innerHeight);
    parserObject_transfers_payment_pay_req["timezone"]     = String((new Date()).getTimezoneOffset());

    let wu_cardpaymentpay_START=new Date(); if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("TransferOnline3_lbl_card2"));}
    wu_TransactionFlow
    .wu_cardpaymentpay(parserObject_transfers_payment_pay_req)
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_cardpaymentpay",JSON.stringify(res));
      localStorage.setItem("MTCN", "");
      let renderContent     = "";
      let mtcn              = "";
      let LanguageCode      = "";
      let parserObject_cardpaymentpay = null;
      try{ parserObject_cardpaymentpay = JSON.parse(localStorage.getItem("parserObject_cardpaymentpay"));} catch(err){;}
      try{ renderContent     = parserObject_cardpaymentpay["renderContent"]; }catch(err){renderContent = "";}
      try{ mtcn              = parserObject_cardpaymentpay["mtcn"];          }catch(err){mtcn          = "";}
      LanguageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
      if(renderContent==="" || (typeof renderContent ==="undefined") || renderContent===null){
        localStorage.setItem("transfers_tokenizedPaymentMethod",  "transfers_tokenizedPaymentMethod_without3DS");
        try{     Cookies.set('transfers_tokenizedPaymentMethod',  "transfers_tokenizedPaymentMethod_without3DS", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
        if(mtcn!=="" && (typeof mtcn!=="undefined") && mtcn!==null){
          localStorage.setItem("MTCN", mtcn);
        }
        //+++++++++++++++
        //Goto Controller
        //+++++++++++++++
        history.push(wu_Utilities.getNavigationURLs("TransferOnline4c3"));
      }
      else{
        localStorage.setItem("transfers_tokenizedPaymentMethod", "transfers_tokenizedPaymentMethod_with3DS");
        try{     Cookies.set('transfers_tokenizedPaymentMethod', "transfers_tokenizedPaymentMethod_with3DS", {secure:true,expires:1,path:api.webapp_path}); }catch(err){console.log(methName+"err="+err);}
        this.setState({
          html                                                 : new Buffer(renderContent).toString('base64'),
          MTCN                                                 : mtcn,
          LanguageCode                                         : LanguageCode,
        });
        setTimeout(function() { //Start the timer
          if (typeof document.getElementById('cardPaymentFormTokenized').submit === "object") {
              document.getElementById('cardPaymentFormTokenized').submit.remove();
          }
          document.getElementById('cardPaymentFormTokenized').submit();
        }.bind(this), 500);
      }
    })
    .catch(err => {
      let wu_cardpaymentpay_dur=wu_Utilities.diffDatesSec(wu_cardpaymentpay_START);console.log(methName+"wu_cardpaymentpay_dur="+wu_cardpaymentpay_dur);
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---card_tokenized
      console.log(methName+"err="+JSON.stringify(err));
           if(err && err.returnCode && err.returnCode===100) { console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage")); }
      else if(err && err.returnCode && err.returnCode===6001){ this.dialog_handleOpen(               this.NSInforString("TransferOnline3_lbl_card_error_1")); } //===>TransferOnline3(STAY in the same screen)
      else if(err && err.returnCode && err.returnCode===6002){ this.dialog_gotoController_handleOpen(this.NSInforString("TransferOnline3_lbl_card_error_2")); } //===>HistoryList
      else if(err && err.returnCode && err.returnCode===6003){ this.dialog_goBack_handleOpen(        this.NSInforString("TransferOnline3_lbl_card_error_3")); } //===>TransferOnlineCards
      else if(err && err.returnCode && err.returnCode===6004){ this.dialog_handleOpen(               this.NSInforString("TransferOnline3_lbl_card_error_4")); } //===>TransferOnline3(STAY in the same screen)
      else if(err && err.returnCode && err.returnCode!==0)   { this.dialog_handleOpen(err.returnText,"NET"); }
      else if(wu_cardpaymentpay_dur>=59)                     { this.dialog_gotoController_handleOpen(this.NSInforString("TransferOnline3_msg_60sec"),"NET"); }
      else                                                   { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_normal_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_card_normal(event) {
    let methName = filename+"btn_proceed_act_card_normal ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(emptyFields===true){this.stopLockers();return;}
    }
    //-----------------------
    //validate cardHolderName
    //-----------------------
    let textField1text = this.state.textField1.trim();
    if(textField1text === ""){ //VLDT:empty
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline3_plh1")+"\"");
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    if(wu_Utilities.offline_validate_latinCharacters(textField1text.replace(/ /g,"").replace(/\./g,""))===false){
        this.dialog_handleOpen(this.NSInforString("emtpy_field")+"\""+this.NSInforString("TransferOnline3_plh1")+"\" "+this.NSInforString("with_latin"));
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    if(textField1text.length < 2 || textField1text.length > 26 ){
        this.dialog_handleOpen(this.NSInforString("common.cardHolderName.size"));
        this.setState({"textField1_hasError" : true });
        this.stopLockers();return;
    }
    //----------------
    //validate Consent
    //----------------
    /*if(this.state.bool_sel1===false && this.state.bool_sel2===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_consent_err"));
        this.stopLockers();return;
    }*/
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_msg_terms"));
        this.stopLockers();return;
    }

    this.makeHTTPConn_proceed_card_normal();
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_card_normal(){
    let methName = filename+"makeHTTPConn_proceed_card_normal ";
    if(api.print_logs){console.log(methName);}

    //--------------------
    //wu_cardpaymentticket---d2b
    //--------------------
    let textField1text = this.state.textField1.trim();
    let centralID = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b = {};
        try { parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b")); }catch(err){;}
        try { centralID = parserObject_sendoutbound_d2b["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
    }
    else{
        let parserObject_sendoutbound = {};
        try { parserObject_sendoutbound = JSON.parse(localStorage.getItem("parserObject_sendoutbound")); }catch(err){;}
        try { centralID = parserObject_sendoutbound["centralID"]; }catch(err){;} if(centralID === null || (typeof centralID ==="undefined")){centralID = "";}
    }

    if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("TransferOnline3_lbl_card2"));}
    wu_TransactionFlow
    .wu_cardpaymentticket({saveCard:this.state.ShouldSaveCard, centralID:centralID,cardHolderName:textField1text})
    .then(res => {
      if(localStorage.getItem("curr_view").trim()!=="TransferOnline3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
      /*this.stopLockers(); creates problem with double click thats why*/this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES
      localStorage.setItem("parserObject_cardpaymentticket",JSON.stringify(res));
      localStorage.setItem("MTCN", "");
      let merchantReference = "";
      let user              = "";
      let merchantId        = "";
      let posId             = "";
      let acquirerId        = "";
      let LanguageCode      = "";
      let parserObject_cardpaymentticket = null;
      try{ parserObject_cardpaymentticket = JSON.parse(localStorage.getItem("parserObject_cardpaymentticket"));} catch(err){;}
      try{ merchantReference = parserObject_cardpaymentticket["merchantReference"]; }catch(err){merchantReference = "";}
      try{ user              = parserObject_cardpaymentticket["user"];              }catch(err){user              = "";}
      try{ merchantId        = parserObject_cardpaymentticket["merchantId"];        }catch(err){merchantId        = "";}
      try{ posId             = parserObject_cardpaymentticket["posId"];             }catch(err){posId             = "";}
      try{ acquirerId        = parserObject_cardpaymentticket["acquirerId"];        }catch(err){acquirerId        = "";}
      LanguageCode           = localStorage.getItem("lang")==="en" ? "en-US" : "el-GR";
      this.setState({
        merchantReference                                    : merchantReference,
        user                                                 : user,
        merchantId                                           : merchantId,
        posId                                                : posId,
        acquirerId                                           : acquirerId,
        LanguageCode                                         : LanguageCode,
      });
      setTimeout(function() { //Start the timer
        if (typeof document.getElementById('cardPaymentFormNormal').submit === "object") {
            document.getElementById('cardPaymentFormNormal').submit.remove();
        }
        document.getElementById('cardPaymentFormNormal').submit();
      }.bind(this), 500);
    })
    .catch(err => {
      this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---card_normal
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-01)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Other Bank---------------------------------------
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_bank_isDisabled(){

    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  btn_proceed_act_bank(event) {
    let methName = filename+"btn_proceed_act_bank ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    //++++++++++++++++++++++
    //webapp session timeout
    //++++++++++++++++++++++
    if(wu_Utilities.checkIfUserIsLoggedIn()){
      wu_Utilities.update_uilatstats();
      if(!wu_Utilities.check_uilatstats(api.uilatstats_inactivity_mins)){ wu_Utilities.LogoutUserFromApp(filename); history.push(wu_Utilities.getNavigationURLs("LoginPage")); return; }
    }
    //--------------
    //validate Terms---CheckBox
    //--------------
    if(this.state.userAcceptedTerms===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_msg_terms"));
        this.stopLockers();return;
    }
    //----------------
    //validate Consent
    //----------------
    /*if(this.state.bool_sel1===false && this.state.bool_sel2===false){
        this.dialog_handleOpen(this.NSInforString("TransferOnline3_consent_err"));
        this.stopLockers();return;
    }*/



    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
      if(localStorage.getItem("parserObject_sendoutbound_d2b_capitalcontrols") !== ""){
        //this.dialog_handleOpen(this.NSInforString("parserObject_sendoutbound_d2b_capitalcontrols")+this.NSInforString("payment_method"));
        this.makeHTTPConn_proceed_bank();
      }
      else{
        this.makeHTTPConn_proceed_bank();
      }
    }
    else{
      if(localStorage.getItem("parserObject_sendoutbound_capitalcontrols") !== ""){
        //this.dialog_handleOpen(this.NSInforString("parserObject_sendoutbound_capitalcontrols")+this.NSInforString("payment_method"));
        this.makeHTTPConn_proceed_bank();
      }
      else{
        this.makeHTTPConn_proceed_bank();
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_bank(){
      let methName = filename+"makeHTTPConn_proceed_bank ";
      if(api.print_logs){console.log(methName);}

      //----------------
      //finalizeoutbound---prepare
      //----------------
      let parserObject_finalizeoutbound_req = {};
      //-----------
      //wantMktInfo
      //-----------
      /*let wantMktInfo = "";
      if(this.state.bool_sel1===true  && this.state.bool_sel2===false){ wantMktInfo = "1"; }
      if(this.state.bool_sel1===false && this.state.bool_sel2===true) { wantMktInfo = "0"; }
      parserObject_finalizeoutbound_req["wantMktInfo"] = wantMktInfo;*/

      let centralID = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b"));
          centralID = parserObject_sendoutbound_d2b["centralID"]; if(centralID===null){centralID = "";}
      }
      else{
          let parserObject_sendoutbound     = JSON.parse(localStorage.getItem("parserObject_sendoutbound"));
          centralID = parserObject_sendoutbound["centralID"];     if(centralID===null){centralID = "";}
      }
      parserObject_finalizeoutbound_req["isSofort"]  = "0"
      parserObject_finalizeoutbound_req["centralID"] = centralID;

      //----------------
      //finalizeoutbound
      //----------------
      localStorage.setItem("finalizeoutbound_type",api.finalizeoutbound_type_BankTransfer);

      if(this.state.dialog200_isOpen===false){this.dialog200_handleOpen(this.NSInforString("please_wait"));}
      //-------------------
      //wu_finalizeoutbound
      //-------------------
      wu_TransactionFlow
      .wu_finalizeoutbound(parserObject_finalizeoutbound_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="TransferOnline3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(res.returnCode!==0){ this.stopLockers();this.stopSpinners();this.dialog200_handleClose(); this.dialog_handleOpen(res.returnText); return; }
        if(res.returnCode===0){
          localStorage.setItem("parserObject_finalizeoutbound",JSON.stringify(res));
          //-------------------
          //wu_validatecustomer
          //-------------------
          wu_ProfileService
          .wu_validatecustomer({})
          .then(res => {
            if(localStorage.getItem("curr_view").trim()!=="TransferOnline3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
            this.makeHTTPConn_proceed_bank_TagEventRecording();
            localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
            setTimeout(function(){
              //+++++++++++++++
              //Goto Controller
              //+++++++++++++++
              history.push(wu_Utilities.getNavigationURLs("TransferOnline4b"));
            }, 200);
          })
          .catch(err => {
            this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---bank
            console.log(methName+"err="+JSON.stringify(err));
            if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-03)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
            else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
          });
        }
      })
      .catch(err => {
        this.stopLockers();this.stopSpinners();this.dialog200_handleClose();//stop DialogSpinner = YES---bank
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){console.log("!!!!!!!!!!Logout("+filename+"-04)!!!!!!!!!!");wu_Utilities.LogoutUserFromApp(filename);history.push(wu_Utilities.getNavigationURLs("LoginPage"));} this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  makeHTTPConn_proceed_bank_TagEventRecording(){
      let methName = filename+"makeHTTPConn_proceed_bank_TagEventRecording ";
      if(api.print_logs){console.log(methName);}

      //-------------------
      //Tag Event Recording
      //-------------------
      let shouldUseTagManager = true;//api.shouldUseTagManager;
      if(shouldUseTagManager===true){
        let centralID       = this.get_centralID();       //
        let snd_curr        = 'EUR';                      //
      //let rcv_curr        = this.get_rcv_curr();        //
        let dest_ctry_wu_id = this.get_dest_ctry_wu_id(); //GR,AL
        let mtcn            = this.get_mtcn();
        let gross           = this.get_gross();           //
        let paymentType     = 'banktransfer';             //'banktransfer', 'paybycard'
        let transferMethod  = (localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "cash" : "d2b";
        let brand           = '';//(localStorage.getItem("TransferOnline1_TransferMethod")===api.TransferOnline1_TransferMethod_Cash) ? "Store Pick Up" : "APN-D2B";

        let tagManagerData = {
          'event' : 'purchase',
          'ecommerce': {
            'currencyCode': snd_curr,           //'EUR', // αναλογα με το νομισμα  εκτός αν μετατρέπονται ολα σε eur
            'purchase' : {
              'actionField': {
                'id'          : centralID,      // Transaction ID. Required for purchases and refunds.  ο αριθμός συναλλαγής όχι ο κωδικός πληρωμής του πελάτη
                'affiliation' : paymentType,    // προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'revenue'     : gross,          // Total transaction value (incl. tax and shipping). Ανάλογα με το νόμισμα εκτός αν τα μετατρέπετε ολα σε eur οπότε αντίστοιχα
                'tax'         : '',             // σε περίπτωση που εχουν νόημα τα πεδία αυτα
                'shipping'    : '',             // σε περίπτωση που έχουν νόημα τα πεδια αυτά, Πχ Προμήθεια συναλλαγής
                'coupon'      : '',             // σε περίπτωση που εχουν νόημα τα πεδια αυτα
              },
              'products' : [{                   // List of productFieldObjects.
                'name'     : paymentType,       // Name or ID is required., προτείνουμε να παίρνει τιμές paybycard/banktransfer ανάλογα με το τι εχει επιλέξει ο κάθε πελατης
                'id'       : mtcn,              // προτείνουμε να παίρνει τιμές τον κωδικό πληρωμής όταν μιλάμε για μεταφορα μεσω τραπεζας ή ένα σταθερό id όταν μιλάμε για πληρωμή μέσω κάρτας
                'price'    : gross,             //
                'brand'    : brand,             //σε περίπτωση που έχει νόημα το πεδιο αυτό μπορούμε να το χρησιμοποιήσουμε για έξτρα πληροφορίες
                'category' : dest_ctry_wu_id,   //χωρα που παει το έμβασμα,
                'variant'  : transferMethod,    //[cash/d2b]
                'quantity' : 1,
              }],
            }
          }
        };
        //TagManager.dataLayer(tagManagerData);
        try { window.dataLayer.push(tagManagerData);                }catch(err1){console.log(methName+"err1="+err1);}
        try { console.log(methName+JSON.stringify(tagManagerData)); }catch(err2){console.log(methName+"err2="+err2);}
      }
      //----------------------
      //Criteo Event Recording
      //----------------------
      let shouldUseCriteo = api.shouldUseCriteo;
      if(shouldUseCriteo===true && api.webappENV==="PROD"){
        try {
          let email           = localStorage.getItem("HTTP_user");
          let centralID       = this.get_centralID();       //
        //let gross           = this.get_gross();           //
          window.criteo_q = window.criteo_q || [];
          var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
          window.criteo_q.push(
           { event: "setAccount", account: api.criteo_account }, // You should never update this line
           { event: "setEmail", email: email },                  // Can be an empty string
           { event: "setSiteType", type: deviceType},
           { event: "trackTransaction", id: centralID, item: [{id:"1", price:1, quantity:1}] }
          );
        }catch(err0){console.log(methName+"err0="+err0);}
      }
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_centralID(){
    let methName = filename+"get_centralID ";
    if(api.print_logs){console.log(methName);}

    try {
      let centralID = "";
      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_sendoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b"));
          centralID = parserObject_sendoutbound_d2b["centralID"]; if(centralID===null){centralID = "";}
      }
      else{
          let parserObject_sendoutbound     = JSON.parse(localStorage.getItem("parserObject_sendoutbound"));
          centralID = parserObject_sendoutbound["centralID"];     if(centralID===null){centralID = "";}
      }
      if(centralID === null || (typeof centralID ==="undefined")){ return ""; }
      return centralID;
    }catch(err0){console.log(methName+"err0="+err0);}

    return "";
  }
  //----------
  get_principal(){
    //let methName = filename+"get_principal ";
    //if(api.print_logs){console.log(methName);}

    let principal = 0.0;
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        try {principal = parserObject_sendoutbound_d2b_req["principal"]; }catch(err){;}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        try {principal = parserObject_sendoutbound_req["principal"]; }catch(err){;}
    }
    if(principal === null || (typeof principal ==="undefined")){ return ""; }
    return principal;
  }
  //----------
  get_rcv_curr(){
    //let methName = filename+"get_rcv_curr ";
    //if(api.print_logs){console.log(methName);}

    let rcv_curr   = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_d2b_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        try {rcv_curr  = parserObject_sendoutbound_req["rcv_curr"];  }catch(err){;} if(rcv_curr === null || (typeof rcv_curr==="undefined")){rcv_curr = "";}
    }
    if(rcv_curr === null || (typeof rcv_curr ==="undefined")){ return ""; }
    return rcv_curr;
  }
  //----------
  get_gross(){
    let methName = filename+"get_gross ";
    //if(api.print_logs){console.log(methName);}

    let gross = 0.0;
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_validateoutbound_d2b = {};
        try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err1){ console.log(methName+'err1='+err1); }
        try {gross = parserObject_validateoutbound_d2b["gross"]; }catch(err2){ console.log(methName+'err2='+err2); }
    }
    else{
        let parserObject_validateoutbound = {};
        try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err3){ console.log(methName+'err3='+err3); }
        try {gross = parserObject_validateoutbound["gross"]; }catch(err4){ console.log(methName+'err4='+err4); }
    }
    if(gross === null || (typeof gross ==="undefined")){ return ""; }
    return gross.toFixed(2);
  }
  //----------
  get_normalCharges(){
    //let methName = filename+"get_normalCharges ";
    //if(api.print_logs){console.log(methName);}

    let normalCharges = 0.0; //float
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_validateoutbound_d2b = {};
        try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err){;}
        try {normalCharges = parserObject_validateoutbound_d2b["normalCharges"]; }catch(err){;} if(normalCharges === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
    }
    else{
      let parserObject_validateoutbound = {};
      try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err){;}
      try {normalCharges = parserObject_validateoutbound["normalCharges"]; }catch(err){;} if(normalCharges === null || (typeof normalCharges==="undefined")){ normalCharges = 0.0;}
    }
    if(normalCharges === null || (typeof normalCharges ==="undefined")){ return ""; }
    return normalCharges.toFixed(2);
  }
  //----------
  get_expectedActualPayout(){
    //let methName = filename+"get_expectedActualPayout ";
    //if(api.print_logs){console.log(methName);}

    let expectedActualPayout = 0.0; //float
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_validateoutbound_d2b = {};
        try { parserObject_validateoutbound_d2b = JSON.parse(localStorage.getItem("parserObject_validateoutbound_d2b")); }catch(err){;}
        try {expectedActualPayout = parserObject_validateoutbound_d2b["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
    }
    else{
      let parserObject_validateoutbound = {};
      try { parserObject_validateoutbound = JSON.parse(localStorage.getItem("parserObject_validateoutbound")); }catch(err){;}
      try {expectedActualPayout = parserObject_validateoutbound["expectedActualPayout"];  }catch(err){;} if(expectedActualPayout === null || (typeof expectedActualPayout==="undefined")){ expectedActualPayout = 0.0;}
    }
    if(expectedActualPayout === null || (typeof expectedActualPayout ==="undefined")){ return ""; }
    return expectedActualPayout.toFixed(2);
  }
  //----------
  get_dest_ctry_wu_id(){
    let destCountryDescription = localStorage.getItem("TransferOnline1_selCountry_ctry_wu_id");
    return destCountryDescription;
  }
  //----------
  get_mtcn(){
    //let methName = filename+"get_mtcn ";
    //if(api.print_logs){console.log(methName);}

    let parserObject_finalizeoutbound = {};
    try { parserObject_finalizeoutbound = JSON.parse(localStorage.getItem("parserObject_finalizeoutbound")); }catch(err){;}
    let mtcn  = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        try {mtcn  = parserObject_finalizeoutbound["mtcn"]; }catch(err){;} if(mtcn  === null || (typeof mtcn ==="undefined")){mtcn  = " - ";}
    }
    else{
        try {mtcn  = parserObject_finalizeoutbound["mtcn"]; }catch(err){;} if(mtcn  === null || (typeof mtcn ==="undefined")){mtcn  = " - ";}
    }
    return mtcn;
  }
  //----------
  get_rcv_fname(){
    //let methName = filename+"get_rcv_fname ";
    //if(api.print_logs){console.log(methName);}

    let rcv_fname   = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        //if(api.print_logs){console.log('parserObject_sendoutbound_d2b_req='+localStorage.getItem("parserObject_sendoutbound_d2b_req"));}
        try {rcv_fname = parserObject_sendoutbound_d2b_req["rcv_fname"]; }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        //if(api.print_logs){console.log('parserObject_sendoutbound_req='+localStorage.getItem("parserObject_sendoutbound_req"));}
        try {rcv_fname = parserObject_sendoutbound_req["rcv_fname"]; }catch(err){;} if(rcv_fname === null || (typeof rcv_fname==="undefined")){rcv_fname = "";}
    }
    if(rcv_fname === null || (typeof rcv_fname ==="undefined")){ return ""; }
    return rcv_fname;
  }
  //----------
  get_rcv_lname(){
    //let methName = filename+"get_rcv_lname ";
    //if(api.print_logs){console.log(methName);}

    let rcv_lname   = "";
    if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = {};
        try { parserObject_sendoutbound_d2b_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_d2b_req")); }catch(err){;}
        //if(api.print_logs){console.log('parserObject_sendoutbound_d2b_req='+localStorage.getItem("parserObject_sendoutbound_d2b_req"));}
        try {rcv_lname = parserObject_sendoutbound_d2b_req["rcv_lname"]; }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
    }
    else{
        let parserObject_sendoutbound_req = {};
        try { parserObject_sendoutbound_req = JSON.parse(localStorage.getItem("parserObject_sendoutbound_req")); }catch(err){;}
        //if(api.print_logs){console.log('parserObject_sendoutbound_req='+localStorage.getItem("parserObject_sendoutbound_req"));}
        try {rcv_lname = parserObject_sendoutbound_req["rcv_lname"]; }catch(err){;} if(rcv_lname === null || (typeof rcv_lname==="undefined")){rcv_lname = "";}
    }
    if(rcv_lname === null || (typeof rcv_lname ==="undefined")){ return ""; }
    return rcv_lname;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    if(api.print_logs){console.log(stateVar+" "+event.target.value);}

    // if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
    //   this.setState({"textField0":eventTMP.trim(),});
    // }
    if(stateVar==="textField1"){
      eventTMP = eventTMP.toUpperCase();
      this.setState({
        "textField1"          : eventTMP,
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      if(eventTMP.length>0 && wu_Utilities.offline_validate_latinCharacters(eventTMP.replace(/ /g,"").replace(/\./g,""))===false){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin")); this.setState({"textField1_hasError":true}); return; }
    //if(eventTMP.trim().length > 26 || eventTMP.trim().length < 2){ this.Snackbar_textField_handleOpen(this.NSInforString("common.cardHolderName.size")); this.setState({"textField1_hasError":true}); return; }
      if(eventTMP.trim().length > 26){ this.Snackbar_textField_handleOpen(this.NSInforString("common.cardHolderName.size")); this.setState({"textField1_hasError":true}); return; }
      else                           { this.setState({"textField1_hasError":false}); }
    }
    else{
      this.setState({ [stateVar] : event.target.value });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    if(key==="MTCN") { return wu_Utilities.wu_verifyMTCN(val);  }

    return false;
  }
  importAll(r) {
    //return r.keys().map(r);
    let images = {};
    r.keys().map((item, index) => {
      images[item.replace('./', '')] = r(item);
      return "";
    });
    return images;
  }
  //----------------------------------------------------------------------------------------------------
  comvert2ProperAmountFormat(amountStr){
    try{
      let parts = amountStr.split('.');
      let part1 = this.numberWithCommas(parts[0]);
      let part2 = parts[1];
      return part1+","+part2;
    }catch(err){;}
    return amountStr;
  }
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  //----------------------------------------------------------------------------------------------------
  load_cookies_to_localStorage(){
    let methName = filename+"load_cookies_to_localStorage ";
    if(api.print_logs){console.log(methName);}

    try{
      console.log("Cookies.get(lang)       = "+Cookies.get('lang'));
      console.log("Cookies.get(isLoggedIn) = "+Cookies.get('isLoggedIn'));
      if(localStorage.getItem("isLoggedIn")==="true"){
        console.log("localStorage is not wiped out");
        return;
      }
      localStorage.setItem("lang",                          Cookies.get('lang'));
      localStorage.setItem("isLoggedIn",                    Cookies.get('isLoggedIn'));
      localStorage.setItem("accessToken",                   Cookies.get('accessToken'));
      localStorage.setItem("refreshToken",                  Cookies.get('refreshToken'));
      localStorage.setItem("tokenID",                       Cookies.get('tokenID'));
      localStorage.setItem("centralID",                     Cookies.get('centralID'));
      localStorage.setItem("TransferOnline1_PaymentMethod", Cookies.get('TransferOnline1_PaymentMethod'));
      localStorage.setItem("TransferOnline1_TransferMethod",Cookies.get('TransferOnline1_TransferMethod'));
      localStorage.setItem("parserObject_sendoutbound_d2b", JSON.stringify({"centralID":Cookies.get('centralID')}));
      localStorage.setItem("parserObject_sendoutbound",     JSON.stringify({"centralID":Cookies.get('centralID')}));

      localStorage.setItem("TransferOnline1_selCountry_ctry_wu_id",Cookies.get('TransferOnline1_selCountry_ctry_wu_id'));

      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
          let parserObject_validateoutbound_d2b = { "gross":parseFloat(Cookies.get('gross')), "normalCharges":parseFloat(Cookies.get('normalCharges')), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
          localStorage.setItem("parserObject_validateoutbound_d2b",JSON.stringify(parserObject_validateoutbound_d2b));
      }
      else{
        let parserObject_validateoutbound       = { "gross":parseFloat(Cookies.get('gross')), "normalCharges":parseFloat(Cookies.get('normalCharges')), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_validateoutbound",JSON.stringify(parserObject_validateoutbound));
      }

      if(localStorage.getItem("TransferOnline1_TransferMethod") === api.TransferOnline1_TransferMethod_Bank){
        let parserObject_sendoutbound_d2b_req = { "rcv_fname":Cookies.get('rcv_fname'), "rcv_lname":Cookies.get('rcv_lname'), "rcv_curr":Cookies.get('rcv_curr'), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_sendoutbound_d2b_req",JSON.stringify(parserObject_sendoutbound_d2b_req));
      }
      else{
        let parserObject_sendoutbound_req     = { "rcv_fname":Cookies.get('rcv_fname'), "rcv_lname":Cookies.get('rcv_lname'), "rcv_curr":Cookies.get('rcv_curr'), "principal":parseFloat(Cookies.get('principal')), "expectedActualPayout":parseFloat(Cookies.get('expectedActualPayout')) };
        localStorage.setItem("parserObject_sendoutbound_req",JSON.stringify(parserObject_sendoutbound_req));
      }
    } catch(err){
      console.log(methName+"err="+err);
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {

    //console.log("goBack "+localStorage.getItem("prev_view").trim());
    if(localStorage.getItem("prev_view").trim()==="TransferOnline3"){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("TransferOnline2"));
    }
    else{
      //history.go(-1);
      history.goBack();
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg,dType){
    if(dType==="NET"){
      setTimeout(function() {
        this.setState({
          "dialog_isOpen" : true,
          "dialog_msg"    : dialog_msg
        });
      }.bind(this), api.initialLoadGracePeriodMS);
      return;
    }
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups goBack-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_goBack_handleOpen(dialog_msg){
    setTimeout(function() {
      this.setState({
        "dialog_goBack_isOpen" : true,
        "dialog_goBack_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_goBack_btn_OK(){
    let methName = filename+"dialog_goBack_btn_OK ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog_goBack_isOpen": false });

    let parserObject_cards_res = [];
    try{ parserObject_cards_res = JSON.parse(localStorage.getItem("parserObject_cards_res"));}catch(err){console.log(methName+'err='+err);parserObject_cards_res = [];}
    if(parserObject_cards_res.length > 0){
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("TransferOnlineCards"));
    }
    else{
      //+++++++++++++++
      //Goto Controller
      //+++++++++++++++
      history.push(wu_Utilities.getNavigationURLs("TransferOnline2"));
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups gotoController-----------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_gotoController_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_gotoController_isOpen" : true,
        "dialog_gotoController_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_gotoController_btn_OK(){
    let methName = filename+"dialog_gotoController_btn_OK ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog_gotoController_isOpen": false });
    //+++++++++++++++
    //Goto Controller
    //+++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("HistoryList"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( TransferOnline3_continue_locked===true ){ return true;  }
    else                                        { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    TransferOnline3_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    TransferOnline3_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------DialogSpinner-------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog200_handleOpen(dialog_msg){
    this.setState({
      "dialog200_isOpen" : true,
      "dialog200_msg"    : dialog_msg
    });
  }
  //----------------------------------------------------------------------------------------------------
  dialog200_handleClose(){
    //this.setState({ "dialog200_isOpen": false });
    setTimeout(function() {
      this.setState({ "dialog200_isOpen": false });
    }.bind(this), api.initialLoadGracePeriodMS);
  }
  //----------------------------------------------------------------------------------------------------
  //----------------------------------------------------------------------------------------------------
  get_url_FromObj(obj){
    if(obj && obj.photo){
      return obj.photo;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
  get_name_FromObj(obj){
    if(obj && obj.name){
      return obj.name;
    }
    return " - ";
  }
  //----------------------------------------------------------------------------------------------------
}
TransferOnline3.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(TransferOnline3Style)(TransferOnline3)
);
